import { Component, Inject } from "@angular/core";
import { MAT_BOTTOM_SHEET_DATA } from "@angular/material/bottom-sheet";

@Component({
    template: `
        <iframe *ngIf="data.conversationUrl" 
                [src]="data.conversationUrl | safeUrl" 
                allow="microphone *;" 
                width="420"
                height="420"
                frameborder="0"></iframe>
    `})
export class JamBottomSheetComponent {

    constructor(@Inject(MAT_BOTTOM_SHEET_DATA) public data: { conversationUrl: string }) {}
}